import { render, staticRenderFns } from "./PrmClient.vue?vue&type=template&id=10b80881&scoped=true&"
import script from "./PrmClient.vue?vue&type=script&lang=js&"
export * from "./PrmClient.vue?vue&type=script&lang=js&"
import style0 from "./PrmClient.vue?vue&type=style&index=0&id=10b80881&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b80881",
  null
  
)

component.options.__file = "PrmClient.vue"
export default component.exports